import React from 'react';

interface LoadingSpinnerProps {
    size?: 'sm' | 'md' | 'lg' | 'xl';
    className?: string;
}

const sizeClasses = {
    sm: 'h-5 w-5 border-2',
    md: 'h-8 w-8 border-3',
    lg: 'h-12 w-12 border-4',
    xl: 'h-16 w-16 border-4'
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'md', className = '' }) => (
    <div className={`relative inline-flex items-center justify-center`}>
        <div className={`animate-spin rounded-full border-t-brand-600 border-r-brand-400 border-b-transparent border-l-transparent ${sizeClasses[size]} ${className}`}></div>
    </div>
);

interface LoadingPageProps {
    message?: string;
}

export const LoadingPage: React.FC<LoadingPageProps> = ({ message = 'Loading Nestly Portal...' }) => (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-950 text-slate-100">
        <div className="p-8 rounded-2xl bg-slate-900/80 border border-slate-800 backdrop-blur-xl shadow-2xl flex flex-col items-center max-w-sm w-full mx-4">
            <div className="w-12 h-12 rounded-xl bg-brand-500/10 flex items-center justify-center mb-4">
                <LoadingSpinner size="lg" className="border-t-brand-400" />
            </div>
            <h3 className="text-base font-semibold text-slate-200">{message}</h3>
            <p className="text-xs text-slate-400 mt-1">Synchronizing platform state...</p>
        </div>
    </div>
);

interface LoadingOverlayProps {
    message?: string;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ message }) => (
    <div className="absolute inset-0 bg-slate-950/70 backdrop-blur-md flex items-center justify-center z-50 rounded-xl transition-all">
        <div className="text-center p-6 rounded-xl bg-slate-900/90 border border-slate-800 shadow-2xl">
            <LoadingSpinner size="lg" />
            {message && <p className="mt-3 text-slate-300 text-sm font-medium">{message}</p>}
        </div>
    </div>
);
